import React, { useEffect, useState } from 'react';
import PageWrapper from '../layouts/Index';
import PageTitle from './PageTitle';
import { Form, Formik } from "formik";
import CustomInputField from './CustomInputField';
import { oxygenFormOTPSchema } from "../utils/formValidationSchema";
import { useSelector } from 'react-redux';

const OxygenOTPComponent = ({ title, handleResendOTP, handleProceed, consentText }) => {
  const [resendCountdown, setResendCountdown] = useState(30); // Start countdown at 30s
  const isLoading = useSelector((state) => state.oxygenRetail?.otpLoading);

  useEffect(() => {
    if (resendCountdown > 0) {
      const timer = setInterval(() => {
        setResendCountdown(prev => prev - 1);
      }, 1000);

      return () => clearInterval(timer); // Cleanup interval on unmount
    }
  }, [resendCountdown]); // Re-run effect when resendCountdown changes

  const initialValues = {
    otpValue: "",
  };

  const handleSubmit = async (values, actions) => {
    handleProceed(values.otpValue);
    actions.resetForm();
  };

  return (
    <PageWrapper>
      <PageTitle title="Validate OTP" />
      <div className="row">
        <div className="col-md-12">
          {title && (
            <div className="card">
              <div className="card-body">
                <h4><b>{title}</b></h4>
              </div>
            </div>
          )}
        </div>
        <div className="col-md-12">
          <div className="card">
            <div className="card-body text-center">
              <div className="row justify-content-center">
                <div className="col-md-6 d-flex justify-content-center">
                  <div className="terms">
                    <Formik
                      initialValues={initialValues}
                      validationSchema={oxygenFormOTPSchema}
                      onSubmit={(values, actions) => handleSubmit(values, actions)}
                    >
                      {({
                        errors,
                        touched,
                        values,
                        handleBlur,
                        handleChange,
                        isSubmitting,
                      }) => (
                        <Form>
                          <CustomInputField
                            label={consentText ||"Enter OTP to consent to the Terms and Conditions"}
                            placeholder="eg. 123456"
                            name="otpValue"
                            type="text"
                            value={values.otpValue}
                            error={errors.otpValue}
                            onBlur={handleBlur}
                            touched={touched.otpValue}
                            onChange={handleChange}
                          />

                          <button
                            type="button"
                            className="btn btn-dark text-white mr-3"
                            disabled={isSubmitting || resendCountdown > 0}
                            onClick={() => {
                              handleResendOTP();
                              setResendCountdown(30); // Reset countdown when OTP is resent
                            }}
                          >
                            {resendCountdown > 0 ? `Resend OTP in ${resendCountdown}s` : "Resend OTP"}
                          </button>

                          <button
                            type="submit"
                            className="btn btn-primary text-white"
                            disabled={isSubmitting || isLoading}
                          >
                            {isLoading? "Please wait..." : isSubmitting ? "Please wait..." : "Proceed"}
                          </button>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default OxygenOTPComponent;
